import { Container } from "react-bootstrap";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <section className="hero-privacy">
        <Container>
          <div className="hero-content">
            <span>Privacy Policy</span>
            <h1>GPS Area Measure - FieldCalc</h1>
            <p>
              With the given policy, we notify the laws, rules, limitations,
              conditions,
              <br />
              and terms of services when you use our app.
            </p>
          </div>
        </Container>
      </section>

      <section className="privacy-policy">
        <Container>
          <div className="privacy-policy-content">
            <div className="mb-30">
              <h2>1. Privacy Policy</h2>
              <p>
                We recognize that privacy is significant. This Privacy Policy
                applies to the GPS Area Measure - FieldCalc app. We has created
                this Policy to explain our privacy practices so you can
                understand what information about you is collected, used and
                disclosed. We collect information from you in order to provide
                corresponding service and better user experience. With your
                consent of this Privacy Policy, your usage, statistics, input
                while using our apps would be collected.
              </p>
            </div>

            <div className="mb-30">
              <h2>2. Information We Collect</h2>
              <ul>
                <li>
                  Generally. We may collect personal information from our users
                  in order to provide you with a personalized, useful and
                  efficient experience. The categories of information we collect
                  can include: Social network's personal information and
                  device's gallery pictures.
                </li>
                <li>
                  Non-personal identification. We may collect non-personal
                  identification information about installed applications,
                  application usage information and device information. The
                  information you give us, for example, when you give us your
                  opinions to our application and services via our feedback
                  channel, such as your email address, and names.
                </li>
              </ul>
            </div>

            <div className="mb-30">
              <h2>3. How We Use Collected Information</h2>
              <p>
                We can use this information to improve the following services :
              </p>
              <ul>
                <li>To personalize user experience;</li>
                <li>
                  To help develop our service- We may use Non- Personal
                  Information to provide, maintain, improve and develop our
                  services;
                </li>
                <li>
                  We may collect your non-personal information and use them for
                  our market and promotion purpose, for example, we may promote
                  or recommend more relevant apps to you.
                </li>
              </ul>
              <p>
                We use this information to operate, maintain, and provide to you
                the features and functionality of our Apps, as well as to
                communicate directly with you, such as to send you email
                messages and push notifications. We may also send you
                Service-related emails or messages (e.g., account verification,
                order confirmations, change or updates to features of our apps,
                technical and security notices). We use permission like
                GET_ACCOUNTS , READ_PROFILE , READ_CONTACTS , WRITE_CONTACTS .
              </p>
            </div>

            <div className="mb-30">
              <h2>4. How Your Information May Be Disclosed</h2>
              <ul>
                <li>
                  Personal Information - We do not store Personal Information
                  and therefore we do not disclose your Personal Information.
                </li>
                <li>
                  Non-Personal Information - We do not combine Non-Personal
                  Information with Personal Information (such as combining your
                  name with your unique User Device number).
                </li>
                <li>
                  {" "}
                  We not disclose your non-personal information for promotion
                  purpose.
                </li>
              </ul>
            </div>

            <div className="mb-30">
              <h2>5. Third Party Sites</h2>
              <p>
                In general, the Applications, the Services and the Site access
                third party information (such as your Facebook account
                information) through application interfaces. We may provide
                links to third-party Web sites, such as Facebook, as a service
                to our Users. The Site may also carry advertisements from other
                companies. When you click on links of third parties in an
                Application, the Services or the Site, you may leave the
                Application, the Services or the Site. Some of these third party
                sites may be co-branded with our name/logo or our affiliated
                entity's name/logo, even though they are not operated or
                maintained by us. This Policy does not address, and we are not
                responsible for, the privacy practices of Web sites operated by
                third parties, whether they are linked to or otherwise
                accessible from an Application, the Services or the Site. The
                inclusion of a link or accessibility of third party Websites
                does not imply endorsement of such third party Website by us
              </p>
            </div>

            <div className="mb-30">
              <h2>6. USERS WITH WHOM YOU SHARE YOUR INFORMATION</h2>
              <p>
                We cannot control the actions of other Users with whom you share
                your information. We cannot, and do not, control the information
                you share with other Users using an Application, the Services or
                the Site (including via Forums) or how such other Users will use
                or share such information. We are not responsible for third
                party circumvention of our security measures.
              </p>
            </div>

            <div className="mb-30">
              <h2>7. Security</h2>
              <p>
                We are very concerned about safeguarding the confidentiality of
                your information. We do not collect Personal Information, and we
                employ administrative, physical and electronic measures designed
                to protect your Non-Personal Information from unauthorized
                access and use. Please be aware that no security measures that
                we take to protect your information is absolutely guaranteed to
                avoid unauthorized access or use of your Non-Personal
                Information which is impenetrable.
              </p>
            </div>

            <div className="mb-30">
              <h2>8. Sensitive Information</h2>
              <p>
                We ask that you not send us, and you not to disclose, any
                sensitive Personal Information (e.g., information related to
                racial or ethnic origin, political opinions, religion or other
                beliefs, health, sexual orientation, criminal background or
                membership in past organizations, including trade union
                memberships) on or through an Application, the Services or the
                Site or otherwise to us.
              </p>
            </div>

            <div className="mb-30">
              <h2>9. Contacting Us / Reporting Violations</h2>
              <p>
                If you have any questions or comments about this Policy or our
                privacy practices, or to report any violations of the Policy or
                abuse of an Application, the Services or the Site, please
                contact us at{" "}
                <a href="mailto:coloringpages2018@gmail.com">
                  coloringpages2018@gmail.com
                </a>
                changes to this privacy policy
              </p>
              <p>
                Our Privacy Policy may change from time to time, we will post
                any privacy policy changes on this page, so please review it
                periodically. We may provide you additional forms of notice of
                modifications or updates as appropriate under the circumstances.
              </p>
              <p>
                If you do not agree to any modifications to this Policy, your
                sole recourse is to immediately stop all use of all
                Applications, the Services and the Site. Your continued use of
                any Application, the Services or the Site following the posting
                of any modifications to this Policy will constitute your
                acceptance of the revised Policy. Please note that none of our
                employees or agents has the authority to vary any of our
                Policies.
              </p>
            </div>

            <div className="mb-30">
              <h2>10. Street View Usage</h2>
              <p>
                The Street View feature is provided for informational and
                visualization purposes only. Street View images are not live
                camera feeds and do not provide real-time views of any location.
                The imagery may be outdated and may not reflect current
                conditions. By using this feature, you acknowledge and agree
                that the displayed imagery is historical or previously captured
                content and should not be relied upon as a real-time
                representation of any place.
              </p>
            </div>

            <div className="mb-30">
              <h2>11. Contact</h2>
              <p>
                You can contact us about this privacy statement by writing email
                us at the address below:
              </p>
              <span>Vasundhara Infotech LLP</span>
              <span>
                Email :{" "}
                <a href="mailto:coloringpages2018@gmail.com">
                  coloringpages2018@gmail.com
                </a>
              </span>
              <p>Thank You</p>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
